var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1572 4.2C10.4146 4.2 9.70237 4.495 9.17727 5.0201C8.65217 5.5452 8.35717 6.25739 8.35717 7C8.35717 7.74261 8.65217 8.4548 9.17727 8.9799C9.70237 9.505 10.4146 9.8 11.1572 9.8C11.8998 9.8 12.612 9.505 13.1371 8.9799C13.6622 8.4548 13.9572 7.74261 13.9572 7C13.9572 6.25739 13.6622 5.5452 13.1371 5.0201C12.612 4.495 11.8998 4.2 11.1572 4.2ZM11.1572 11.6667C9.91949 11.6667 8.73251 11.175 7.85734 10.2998C6.98217 9.42466 6.4905 8.23768 6.4905 7C6.4905 5.76232 6.98217 4.57534 7.85734 3.70017C8.73251 2.825 9.91949 2.33333 11.1572 2.33333C12.3948 2.33333 13.5818 2.825 14.457 3.70017C15.3322 4.57534 15.8238 5.76232 15.8238 7C15.8238 8.23768 15.3322 9.42466 14.457 10.2998C13.5818 11.175 12.3948 11.6667 11.1572 11.6667ZM11.1572 0C6.4905 0 2.50517 2.90267 0.890503 7C2.50517 11.0973 6.4905 14 11.1572 14C15.8238 14 19.8092 11.0973 21.4238 7C19.8092 2.90267 15.8238 0 11.1572 0Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f513f21b.svg";
export { ForwardRef as ReactComponent };